import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const CancelCreditsModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "CancelCreditsModalContainer" */
      './CancelCreditsModalContainer'
    ),
  loading: LoadingModal,
});
